



import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// 1. Import Authentication & Public Screens
import Login from "./Authentication/Login";
import PublicScreen from "./Public/PublicScreen"; // <--- THIS WAS MISSING

// 2. Import Component Screens
import Dashboard from "./Components/Dashboard";
import Projects from "./Components/Projects/Projects";
import Plots from "./Components/Plots/Plots";
import Staff from "./Components/Company/Staff";
import MemberList from "./Components/Company/MemberList";
import MemberForm from "./Components/Company/MemberForm";

import MemberDetailsView from "./Components/Company/MemberDetailsView";
import MemberDocuments from "./Components/Company/MemberDocuments";

import PaymentList from "./Components/Company/PaymentList";
import PaymentForm from "./Components/Company/PaymentForm";
import HolidayManager from "./Components/Company/HolidayManager";
import Branches from "./Components/Company/Branches";
import DesignationManager from "./Components/Company/DesignationManager";
import LeadManager from "./Components/Company/LeadManager";
import ChangePassword from "./Authentication/ChangePassword"; 
import PermissionManager from "./Components/Company/PermissionManager";
import CompanyProfile from "./Components/Company/CompanyProfile";
import Agents from "./Components/Company/Agents";
import Receipts from "./Components/Company/Receipts";
import MemberReport from "./Components/Company/MemberReport";
import ReceiptReport from "./Components/Company/ReceiptReport";
import AgentPermissionManager from "./Components/Company/AgentPermissionManager";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Landing & Login Page */}
        <Route path="/" element={<PublicScreen />} />
        <Route path="/login" element={<Login />} />
         <Route path="/change-password" element={<ChangePassword />} />

        {/* Private Management Routes */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/plots" element={<Plots />} />
        <Route path="/staff" element={<Staff />} />

        <Route path="/members" element={<MemberList />} />
<Route path="/members/manage" element={<MemberForm />} />
<Route path="/members/view/:id" element={<MemberDetailsView />} />
<Route path="/members/documents" element={<MemberDocuments />} />

<Route path="/payments" element={<PaymentList />} />
<Route path="/payments/manage" element={<PaymentForm />} />
<Route path="/holidays" element={<HolidayManager />} />

<Route path="/branches" element={<Branches />} />
<Route path="/designations" element={<DesignationManager />} />
<Route path="/leads" element={<LeadManager />} />
<Route path="/access-control" element={<PermissionManager />} />

<Route path="/company-profile" element={<CompanyProfile />} />

<Route path="/agents" element={<Agents />} />
<Route path="/receipts" element={<Receipts />} />
<Route path="/reports/members" element={<MemberReport />} />
<Route path="/reports/receipts" element={<ReceiptReport />} />
<Route path="/agent-permissions" element={<AgentPermissionManager />} />
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;